import StarsModule from './stars.module'

export default StarsModule
